import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Flame, Clock, CheckCircle2, Loader2 } from "lucide-react";
import { useWarmup } from "@/hooks/useWarmup";
import { format } from "date-fns";

export default function AlunoHistoricoAquecimento() {
  const navigate = useNavigate();
  const { prompts, responses, isLoading } = useWarmup();

  const submittedResponses = responses
    .filter(r => r.status === "submitted")
    .map(r => {
      const prompt = prompts.find(p => p.id === r.prompt_id);
      return {
        id: r.id,
        titulo: prompt?.title ?? "Aquecimento",
        resposta: r.answer_text ?? "",
        data: r.submitted_at ? format(new Date(r.submitted_at), "dd/MM/yyyy") : "",
        hora: r.submitted_at ? format(new Date(r.submitted_at), "HH:mm") : "",
      };
    });

  if (isLoading) {
    return (
      <div className="page-container flex items-center justify-center min-h-[50vh]">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="page-container">
      <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="flex items-center gap-4 mb-6">
        <Button variant="ghost" size="icon" onClick={() => navigate("/aluno/carreira")}><ArrowLeft className="w-5 h-5" /></Button>
        <div>
          <h1 className="font-heading text-xl font-bold text-foreground">Histórico</h1>
          <p className="text-sm text-muted-foreground">Suas reflexões de aquecimento</p>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
        className="bg-accent/10 rounded-2xl p-4 border border-accent/20 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center">
            <Flame className="w-5 h-5 text-orange-500" />
          </div>
          <div>
            <p className="font-semibold text-foreground">{submittedResponses.length} aquecimentos concluídos</p>
            <p className="text-xs text-muted-foreground">Continue evoluindo!</p>
          </div>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="space-y-4">
        {submittedResponses.map((item) => (
          <div key={item.id} className="bg-card rounded-2xl p-4 border border-border">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center shrink-0">
                <CheckCircle2 className="w-4 h-4 text-success-foreground" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-foreground">{item.titulo}</h3>
                <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                  <Clock className="w-3 h-3" />{item.data} às {item.hora}
                </p>
              </div>
            </div>
            <div className="bg-secondary rounded-xl p-3 ml-11">
              <p className="text-sm text-foreground">{item.resposta}</p>
            </div>
          </div>
        ))}
      </motion.div>

      {submittedResponses.length === 0 && (
        <div className="bg-muted/50 rounded-2xl p-8 text-center">
          <Flame className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <h3 className="font-heading font-semibold text-foreground mb-2">Nenhum aquecimento ainda</h3>
          <p className="text-sm text-muted-foreground mb-4">Complete atividades para ver seu histórico aqui</p>
          <Button variant="accent" onClick={() => navigate("/aluno/carreira")}>Fazer Aquecimento</Button>
        </div>
      )}
    </div>
  );
}
